export enum VisibilityMonitorEvents {
    Visible = 'Visible',
    Hidden = ' Hidden',
    VisibilityChange = 'VisibilityChange'
}
